const filterContainer = document.querySelector('.offres-emploi-filter');
if (filterContainer) {

    if (window.innerWidth < 768) {
        const filterTitle = document.querySelector('.items-filter__title');
        const filterTitleArrow = document.querySelector('.items-filter__title-arrow');
        filterTitle.addEventListener('click', (e) => {
            e.preventDefault();
            filterTitle.classList.toggle('is-open');
            filterTitleArrow.classList.toggle('is-open');
            filterContainer.querySelector('.items-filter__mobile-dropdown').classList.toggle('is-open');
        })
    }

    const filtersTopContainer = document.querySelectorAll('.items-filter__dropdown-container__top');

    filtersTopContainer.forEach((filterTopContainer) => {
        filterTopContainer.addEventListener('click', (e) => {
            //On ferme tous les autres dropdowns sauf celui qui a été cliqué
            const otherDropDowns = document.querySelectorAll('.items-filter__dropdown-choices.is-open');
            otherDropDowns.forEach((dropDown) => {
                if (dropDown !== filterTopContainer.parentElement.querySelector('.items-filter__dropdown-choices')) {
                    dropDown.classList.remove('is-open');
                    //On selectionne le parent puis l'icon pour changer la direction de la flèche
                    dropDown.parentElement.querySelector('.items-filter__dropdown-container__icon').classList.remove('is-open');
                }
            })
            e.preventDefault();
            const dropDownChoices = filterTopContainer.parentElement.querySelector('.items-filter__dropdown-choices')
            dropDownChoices.parentElement.querySelector('.items-filter__dropdown-container__icon').classList.toggle('is-open');
            dropDownChoices.classList.toggle('is-open');
        })
    });

    (function ($) {
        $(document).ready(function () {

            //Systeme de réduction lors du scroll
            let itemsFilter = $('#items-filter');
            let itemsFilterTop = itemsFilter.offset().top;
            let headerHeight = $('.header__top').outerHeight();

            // I-1 (CLS) : la barre est rendue « collante » par le CSS
            // (#items-filter { position: sticky; top: var(--header-height) }) qui réserve sa
            // place dans le flux en permanence -> zéro layout shift. On ne bascule plus AUCUNE
            // propriété de layout au scroll (fini le padding-top sur #items-wrapper, le
            // position:fixed et le margin-bottom). On n'ajoute qu'une classe d'état purement
            // visuelle (ombre = paint/composite) quand la barre est collée sous le header.
            let isStuck = false;
            $(window).scroll(function () {
                const shouldStick = $(window).scrollTop() >= itemsFilterTop - headerHeight + 20;
                if (shouldStick !== isStuck) {
                    isStuck = shouldStick;
                    itemsFilter.toggleClass('is-fixed', shouldStick);
                }
            });


            //----LOGIQUE DU FILTRE----//
            let currentPage = 1;
            let activitySectorEls = document.querySelectorAll('.items-filter__activity-sector');
            let activitySector = [];
            let searchInput = document.querySelector('.items-filter__search-input');

            activitySectorEls.forEach((activitySectorEl) => {
                activitySectorEl.addEventListener('click', (e) => {
                    e.preventDefault();
                    activitySectorEl.classList.toggle('is-selected');
                    if (activitySectorEl.classList.contains('is-selected')) {
                        activitySector.push(activitySectorEl.getAttribute('data-value'));
                    } else {
                        activitySector = activitySector.filter((item) => {
                            return item !== activitySectorEl.getAttribute('data-value');
                        })
                    }
                    fetchEmplois(activitySector);
                })
            });

            searchInput.addEventListener('keyup', (e) => {
                e.preventDefault();
                fetchEmplois(activitySector, searchInput.value);
            });


            function fetchEmplois(categories, word, page = 1) {
                let itemsWrapper = $('#items-wrapper');
                itemsWrapper.html('');

                let currentLang = $('#current-site-lang').val();
                currentPage = page;

                $('.loader').css('display', 'flex');
                let url = 'https://moovijob.com/api/job-offers/search?page=' + page;

                if (categories) {
                    categories.forEach((category) => {
                        url += '&job_categories[]=' + category;
                    });
                }
                if (word) {
                    url += '&q=' + word;
                }
                url += '&sort_by=date';

                fetch(url)
                    .then(response => response.json())
                    .then(data => {
                        $('.loader').css('display', 'none');
                        createPagination(data.last_page, categories, word);

                        let jobsOffers = data.data;

                        jobsOffers.forEach((jobOffer) => {
                            createJobOfferCard(jobOffer, currentLang, itemsWrapper);
                            window.scrollTo(0, 0);
                        });
                    })
            }
            fetchEmplois();

            function createPagination(maxPages, categories, word) {
                let pagination = $('#pagination');
                pagination.html('');
                let paginationList = $('<ul>').addClass('pagination__list');
                pagination.append(paginationList);

                let displayPages = maxPages;
                if (displayPages > 6) {
                    displayPages = 6;
                }

                let startPage = 1;
                if (currentPage > 5) {
                    startPage = currentPage - 1;
                }

                if (currentPage > maxPages - 5 && maxPages - 5 > 0) {
                    startPage = maxPages - 5;
                }

                for (let i = startPage; i <= maxPages && i < startPage + 6; i++) {
                    let paginationItem = $('<li>').addClass('pagination__item');
                    paginationItem.attr('data-page', i);
                    paginationList.append(paginationItem);
                    let paginationLink = $('<a>').addClass('pagination__link')
                        .attr('href', '#')
                        .text(i);
                    paginationItem.append(paginationLink);

                    if (i === parseInt(currentPage)) {
                        paginationItem.addClass('is-active');
                    }

                    $(paginationItem).click(function (e) {
                        e.preventDefault();
                        let page = $(this).attr('data-page');
                        $('html, body').animate({ scrollTop: 0 }, 500);

                        fetchEmplois(categories, word, page);
                    });
                }

                if (startPage + 5 < maxPages && maxPages > 6) {
                    let paginationItem = $('<li>').addClass('pagination__item');
                    paginationList.append(paginationItem);
                    let paginationLink = $('<span>').addClass('pagination__link')
                        .text('...');
                    paginationItem.append(paginationLink);
                    let paginationItemLast = $('<li>').addClass('pagination__item');
                    paginationItemLast.attr('data-page', maxPages);
                    paginationList.append(paginationItemLast);
                    let paginationLinkLast = $('<a>').addClass('pagination__link')
                        .attr('href', '#')
                        .text(maxPages);
                    paginationItemLast.append(paginationLinkLast);
                    paginationItemLast.click(function (e) {
                        e.preventDefault();
                        let page = $(this).attr('data-page');
                        $('html, body').animate({ scrollTop: 0 }, 500);

                        fetchEmplois(categories, word, page);
                    });
                } else if (maxPages > 6) {
                    let paginationItem = $('<li>').addClass('pagination__item');
                    paginationList.prepend(paginationItem);
                    let paginationLink = $('<span>').addClass('pagination__link')
                        .text('...');
                    paginationItem.append(paginationLink);
                    let paginationItemFirst = $('<li>').addClass('pagination__item');
                    paginationItemFirst.attr('data-page', 1);
                    paginationList.prepend(paginationItemFirst);
                    let paginationLinkFirst = $('<a>').addClass('pagination__link')
                        .attr('href', '#')
                        .text(1);
                    paginationItemFirst.append(paginationLinkFirst);
                    paginationItemFirst.click(function (e) {
                        e.preventDefault();
                        let page = $(this).attr('data-page');
                        $('html, body').animate({ scrollTop: 0 }, 500);

                        fetchEmplois(categories, word, page);
                    });
                }

                //Prev arrow
                let prevItem = $('<li>').addClass('pagination__item__prev');
                let prevLink = $('<a>').addClass('pagination__link__prev')
                    .attr('href', '#')
                    .html('<svg width="24px" height="24px" stroke-width="1.5" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" color="#000000"><path d="M15 6L9 12L15 18" stroke="#000000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path></svg>')
                if (parseInt(currentPage) === 1) {
                    prevItem.addClass('disabled');
                } else {
                    prevLink.attr('data-page', parseInt(currentPage) - 1);
                    prevLink.on('click', function (e) {
                        e.preventDefault();
                        let page = $(this).attr('data-page');
                        $('html, body').animate({ scrollTop: 0 }, 500);

                        fetchEmplois(categories, word, page);
                    });
                }

                prevItem.append(prevLink);
                paginationList.prepend(prevItem);

                //Return to first 
                let returnToFirstItem = $('<li>').addClass('pagination__item__first');
                let returnToFirstLink = $('<a>').addClass('pagination__link__first')
                    .attr('href', '#')
                    .html('<svg width="24px" height="24px" viewBox="0 0 24 24" stroke-width="1.5" fill="none" xmlns="http://www.w3.org/2000/svg" color="#000000"><path d="M11 6L5 12L11 18" stroke="#000000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M19 6L13 12L19 18" stroke="#000000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path></svg>')
                if (parseInt(currentPage) === 1) {
                    returnToFirstItem.addClass('disabled');
                } else {
                    returnToFirstLink.attr('data-page', 1);
                    returnToFirstLink.on('click', function (e) {
                        e.preventDefault();
                        let page = $(this).attr('data-page');
                        $('html, body').animate({ scrollTop: 0 }, 500);

                        fetchEmplois(categories, word, page);
                    });
                }

                returnToFirstItem.append(returnToFirstLink);
                paginationList.prepend(returnToFirstItem);

                // Flèche "Suivant"
                let nextItem = $('<li>').addClass('pagination__item__next');
                let nextLink = $('<a>').addClass('pagination__link__next')
                    .attr('href', '#')
                    .html('<svg width="24px" height="24px" stroke-width="1.5" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" color="#000000"><path d="M9 6L15 12L9 18" stroke="#000000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path></svg>');
                if (parseInt(currentPage) != maxPages) {
                    nextLink.attr('data-page', parseInt(currentPage) + 1);
                    nextLink.on('click', function (e) {
                        e.preventDefault();
                        let page = $(this).attr('data-page');
                        $('html, body').animate({ scrollTop: 0 }, 500);

                        fetchEmplois(categories, word, page);
                    });
                } else {
                    nextItem.addClass('disabled');
                }
                nextItem.append(nextLink);
                paginationList.append(nextItem);


                //Return to last
                let returnToLastItem = $('<li>').addClass('pagination__item__last');
                let returnToLastLink = $('<a>').addClass('pagination__link__last')
                    .attr('href', '#')
                    .html('<svg width="24px" height="24px" viewBox="0 0 24 24" stroke-width="1.5" fill="none" xmlns="http://www.w3.org/2000/svg" color="#000000"><path d="M13 6L19 12L13 18" stroke="#000000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M5 6L11 12L5 18" stroke="#000000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path></svg>')
                if (parseInt(currentPage) === maxPages) {
                    returnToLastItem.addClass('disabled');
                }
                returnToLastLink.attr('data-page', maxPages);
                returnToLastLink.on('click', function (e) {
                    e.preventDefault();
                    let page = $(this).attr('data-page');
                    $('html, body').animate({ scrollTop: 0 }, 500);

                    fetchEmplois(categories, word, page);
                });
                returnToLastItem.append(returnToLastLink);
                paginationList.append(returnToLastItem);
            }

            function createJobOfferCard(job, currentLang, itemsWrapper) {
                //Code de la langue locale du site
                let localLang = $('html').attr('lang');
                let jobOfferCard = $('<a>').addClass('job-offer-card')
                    .attr('href', job.url);
                let jobOfferCardContent = $('<div>').addClass('job-offer-card__content');
                let jobOfferCardContractContainer = $('<div>').addClass('job-offer-card__contract-container');
                if (job.contract_types[0]) {
                    let jobOfferCardContractType = $('<span>').addClass('job-offer-card__contract-type')
                        .text(job.contract_types[0]['short_title'][currentLang]);
                    jobOfferCardContractContainer.append(jobOfferCardContractType);
                }
                let publishedDate = new Date(job.published_at);
                const year = publishedDate.getFullYear();
                const month = publishedDate.getMonth();
                const day = publishedDate.getDate();
                publishedDate = new Date(year, month, day);

                let refreshedDate = null;
                if (job.refresh_at) {
                    refreshedDate = new Date(job.refresh_at);
                    const refreshedYear = refreshedDate.getFullYear();
                    const refreshedMonth = refreshedDate.getMonth();
                    const refreshedDay = refreshedDate.getDate();
                    refreshedDate = new Date(refreshedYear, refreshedMonth, refreshedDay);
                }

                let jobOfferCardDate = '';
                if (refreshedDate) {
                    jobOfferCardDate = $('<span>').addClass('job-offer-card__date')
                        .text(refreshedDate.toLocaleDateString(localLang, { year: 'numeric', month: 'numeric', day: 'numeric' }));
                } else {
                    jobOfferCardDate = $('<span>').addClass('job-offer-card__date')
                        .text(publishedDate.toLocaleDateString(localLang, { year: 'numeric', month: 'numeric', day: 'numeric' }));
                }
                jobOfferCardContractContainer.append(jobOfferCardDate);

                let jobOfferCardTitle = $('<span>').addClass('job-offer-card__title');

                //Si le titre dans la lang courante est vide, on prend le titre dans la langue fr, puis en , puis de
                if (job.title[currentLang]) {
                    jobOfferCardTitle.text(job.title[currentLang]);
                } else if (job.title['de']) {
                    jobOfferCardTitle.text(job.title['de']);
                } else if (job.title['fr']) {
                    jobOfferCardTitle.text(job.title['fr']);
                } else if (job.title['en']) {
                    jobOfferCardTitle.text(job.title['en']);
                }
                let companyName = $('<span>').addClass('job-offer-card__company-name')
                    .text(job.company.name + ' - ' + job.company.city);

                let jobOfferCardIconSvg = '<svg viewBox="0 0 24 24" stroke-width="1.5" fill="none" xmlns="http://www.w3.org/2000/svg" class="job-offer-card__icon"><path d="M9.17137 9.17157L14.8282 14.8284M14.8282 14.8284H9.87848M14.8282 14.8284V9.87867" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path></svg>'
                let jobOfferCardIcon = $('<div>').addClass('job-offer-card__arrow')
                    .html(jobOfferCardIconSvg);

                let jobOfferBody = $('<div>').addClass('job-offer-card__body');
                if (job.body[currentLang]) {
                    //On enlève les balises html
                    let bodyText = job.body[currentLang].replace(/(<([^>]+)>)/gi, "");
                    //On remplace les &nbsp; par des espaces
                    bodyText = bodyText.replace(/&nbsp;/gi, ' ');
                    //On coupe le texte à 200 caractères
                    bodyText = bodyText.substring(0, 200);
                    //on met ... à la fin
                    bodyText += '...';
                    jobOfferBody.text(bodyText);
                } else if (job.body['de']) {
                    let bodyText = job.body['de'].replace(/(<([^>]+)>)/gi, "");
                    bodyText = bodyText.substring(0, 200);
                    bodyText = bodyText.replace(/&nbsp;/gi, ' ');
                    bodyText += '...';

                    jobOfferBody.text(bodyText);
                } else if (job.body['fr']) {
                    let bodyText = job.body['fr'].replace(/(<([^>]+)>)/gi, "");
                    bodyText = bodyText.substring(0, 200);
                    bodyText = bodyText.replace(/&nbsp;/gi, ' ');
                    bodyText += '...';

                    jobOfferBody.text(bodyText);
                } else if (job.body['en']) {
                    let bodyText = job.body['en'].replace(/(<([^>]+)>)/gi, "");
                    bodyText = bodyText.substring(0, 200);
                    bodyText = bodyText.replace(/&nbsp;/gi, ' ');
                    bodyText += '...';

                    jobOfferBody.text(bodyText);
                }

                let viewText = $('<span>').addClass('view-text');
                if (currentLang === 'fr') {
                    viewText.text('Voir l\'offre');
                } else if (currentLang === 'en') {
                    viewText.text('View offer');
                } else if (currentLang === 'de') {
                    viewText.text('Angebot ansehen');
                }
                jobOfferCardIcon.append(viewText);

                jobOfferCardContent.append(jobOfferCardContractContainer);
                jobOfferCardContent.append(jobOfferCardTitle);
                jobOfferCardContent.append(companyName);
                jobOfferCardContent.append(jobOfferBody);
                jobOfferCardContent.append(jobOfferCardIcon);
                jobOfferCard.append(jobOfferCardContent);

                itemsWrapper.append(jobOfferCard);
            }

        })
    })(jQuery)


}